import {
  API_REQUEST,
  API_SUCCESS,
  API_ERROR,
  API_STATUS_RESET,
  UPDATE_AUTH
} from './action-types'

export const apiRequest = (payload, meta) => ({
  type: API_REQUEST,
  meta,
  payload
})

export const updateAuth = (payload, meta) => ({
  type: UPDATE_AUTH,
  meta,
  payload
})

export const setApiSuccess = (payload, meta) => ({
  type: API_SUCCESS,
  meta,
  payload
})

export const setApiError = (error, meta) => ({
  type: API_ERROR,
  meta,
  error
})

export const resetApiStatus = () => ({
  type: API_STATUS_RESET
})

export const setComponentLoading = meta => ({
  type: `${meta.Component.toUpperCase()}_LOADING`,
  meta
})

export const setComponentSuccess = (payload, meta) => ({
  type: `${meta.Component.toUpperCase()}_SUCCESS`,
  meta,
  payload
})

export const setComponentError = (error, meta) => ({
  type: `${meta.Component.toUpperCase()}_ERROR`,
  meta,
  error
})
